import { api } from './api';

export interface Plan {
    id: number;
    name: string;
    price: string;
    is_active: boolean;
    description: string | null;
}

export interface PlansResponse {
    success: boolean;
    message: string;
    data: Plan[];
}

export const getPlans = (): Promise<PlansResponse> =>
    api.get<PlansResponse>('/plans');
